module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Building-6def8f4b9a4b9cc1d2c876f6bc038ff98ef59995f8c4a52d84eab0ef18346e6a.svg";